import React from 'react';
import DynamicWidget from '@com/core/common/components/dynamicWidget';
import { TProductList, THit } from '@com/core/common/types/catalog';
import Loader from '@com/core/kul/components/Loader';
import VerticalProductBoxes from '@com/core/kul/components/productBox/VerticalProductBoxes';
import HorizontalProductBoxCarousel from '@com/core/kul/components/productBox/HorizontalProductBoxCarousel';
import useWindowDimensions from '@com/core/common/hooks/useWindowDimensions';
import ModuleHeaderDotted from '../moduleHeader/ModuleHeaderDotted';

const getParameterByName = (name: string, url: string): string | null => {
    if (!url) {
        return null;
    }
    const newName = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

type TProps = {
    moduleData: TProductList;
};

const ProductList = ({ moduleData }: TProps): JSX.Element => {
    const { initialNum, moduleHeader, productUrl, textColor } = moduleData;

    const { width } = useWindowDimensions(); // #TODO: Hoist this to context? but might not need width always. hmm.

    return (
        <DynamicWidget
            productUrl={productUrl}
            limit={Number(getParameterByName('limit', productUrl)) || initialNum * 2 + 1}>
            {(data: THit | THit[] | null, isLoading: boolean): JSX.Element | null => {
                if (isLoading) {
                    return <Loader />;
                }
                if ((Array.isArray(data) && !data.length) || !data) {
                    return null;
                }
                return (
                    <div>
                        {moduleHeader && <ModuleHeaderDotted data={moduleHeader} textColor={textColor} />}
                        {Array.isArray(data) &&
                            (width > 768 ? (
                                <HorizontalProductBoxCarousel products={data} />
                            ) : (
                                <VerticalProductBoxes products={data} />
                            ))}
                    </div>
                );
            }}
        </DynamicWidget>
    );
};

export default React.memo(ProductList);
